/** Represents a user. */
export class User {

  /**
   * An empty user.
   *
   * @static
   * @type {User}
   * @memberOf User
   */
  static noUser: User = new User(0, '', '', '');

  /**
   * Initializes a User instance.
   * @param {number}  userId     - The users identifier.
   * @param {string}  userName   - The users login name.
   * @param {string}  firstName  - The users first name.
   * @param {string}  lastName   - The users last name.
   */
  constructor(
    public readonly userId: number,
    public readonly userName: string,
    public readonly firstName: string,
    public readonly lastName: string
  ) {}

}
